import { docsURL } from './linkConsts';

export const GET_STARTED_VIDEO_URL =
  'https://www.joinportal.com/video-tutorials';
export const API_DOCS_URL = `${docsURL}/reference/quickstart`;
export const JOIN_SLACK_COMMUNITY_URL =
  'https://join.slack.com/t/portalcommunity/shared_invite/zt-q6stzfgx-vBf7LBtbKFv63W4n_Otx4w';
export const PORTAL_UPDATES_URL = 'https://www.joinportal.com/updates/';
export const ENTERPRISE_INTRO_URL =
  'https://calendly.com/adamportal/enterprise-introduction';
